// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { send } from '../../../actions/network';
import { StorageKeys } from '../../../constants/storage';
import { useLocalStorage } from '../../../hooks';
import useBindActionsCreator from '../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../hooks/useMergeProps';
import { selectUserNickname } from '../../../selectors/user/userPrimary.selector';
import Betshare from '../components/Betshare';
import { betshareSelector } from '../selectors';

type PropsType = {
  height?: number;
  width?: number;
  onClose: () => void;
  betslipReference: string;
};

const BetshareContainer = ({ betslipReference, ...ownProps }: PropsType) => {
  const [showNickname] = useLocalStorage(StorageKeys.USER_PREFS_SHARE_NICKNAME, true);
  const [showStack] = useLocalStorage(StorageKeys.USER_PREFS_SHARE_STACK, true);
  const nickname = useSelector(selectUserNickname);

  let data = null;

  const selectedProps = useSelector((state) => {
    if (data === null || data.needAskBetslipInfo) data = betshareSelector(state, { betslipReference });
    return data;
  });

  const otherProps = useMemo(
    () => ({
      showPseudo: showNickname,
      nickname: nickname,
      showStack: showStack,
    }),
    [nickname, showNickname, showStack],
  );

  const actions = useMemo(
    () => ({
      askBetslipInfo: () => send({ getOneBetslip: { betslipReference } }),
    }),
    [betslipReference],
  );

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps, otherProps });

  return <Betshare {...enhancedProps} />;
};

export default BetshareContainer;
